export function isSeatAvailableAndExistent(seat) {
    return seat.isAvailable && seat.isExistent && !seat.isAisle;
}
